/**
 * Start a Splide carousel's autoplay on the visitor's first input, not at mount.
 *
 * The carousels mount with `autoplay: 'pause'` and hand themselves to this.
 * Chrome keeps updating LCP until the first input, and every slide that moves
 * in is a new image candidate — measured on a throttled phone, an idle
 * homepage's LCP climbed to the hero's slide 2 at ~9.5s. After the first input
 * LCP is final, so rotating from then on costs nothing.
 *
 * Shared by lib/hero.js and lib/front-b.js, which run on one clock: one input
 * starts both, so they stay in step.
 */

// The events that end LCP observation (scroll, key, tap/click). pointermove is
// deliberately not one: it does not stop LCP, so starting on it would bring
// the late candidates back.
const FIRST_INPUT = ['pointerdown', 'keydown', 'wheel', 'scroll', 'touchstart'];

export function startAutoplayOnInput(root, splide) {
  const start = () => {
    FIRST_INPUT.forEach((type) => window.removeEventListener(type, start, true));
    const autoplay = splide.Components.Autoplay;
    autoplay.play();
    // play() clears Splide's hover/focus flags. If the reader is already on
    // the carousel, pause WITHOUT stopping, so mouseleave/blur resumes it.
    if (root.matches(':hover, :focus-within')) autoplay.pause(false);
  };
  FIRST_INPUT.forEach((type) =>
    window.addEventListener(type, start, { capture: true, passive: true })
  );
}
